<template>
  <div
    class="content"
    id="print-this"
    :class="hideWhilePrintingPDF ? 'printtopdf_clean' : ''"
  >
    <modal-loading
      :openModal="fetchProgress > 0 && fetchProgress < 100"
      :value="fetchProgress"
      :label="'Gerando Relatório... ' + fetchProgress.toFixed(0) + '%'"
    >
    </modal-loading>

    <div v-if="hideWhilePrintingPDF" class="pdf-item pb-6">
      <header-relatorio
        :numVisitantes="infoBookingsByVendor[0].visitors.total"
        :numPagantes="infoBookingsByVendor[0].visitors.paying"
        :saldoTotal="infoBookingsByVendor[0].total_transfer"
        :startDate="formDate.startDate"
        :endDate="formDate.endDate"
      >
      </header-relatorio>
    </div>

    <dashboard-page title="Vendas" :hide-header="hideWhilePrintingPDF">
      <template #actions>
        <base-button
          @click="openModalTabelaReservas()"
          :disabled="
            Object.keys(formattedPaidBillItems).length > 0 ? false : true
          "
          class="btn-sm btn-outline-info"
          type="submit"
        >
          Listar reservas
        </base-button>
        <b-dropdown menu on right no-caret id="dropdown-1" variant="secondary">
          <template v-slot:button-content>
            <svg
              width="5"
              height="19"
              viewBox="0 0 5 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2.19231" cy="2.19231" r="2.19231" fill="#12576e" />
              <circle cx="2.19231" cy="9.49992" r="2.19231" fill="#12576e" />
              <circle cx="2.19231" cy="16.8078" r="2.19231" fill="#12576e" />
            </svg>
          </template>

          <b-dropdown-item
            v-if="!loadingTable"
            :disabled="
              Object.keys(formattedPaidBillItems).length > 0 ? false : true
            "
            @click="downloadAsCSV"
            active:loading="loadingTable"
            type="default"
          >
            <i class="no no-data-download"></i>Download CSV</b-dropdown-item
          >
          <b-dropdown-item
            v-if="!loadingTable"
            :disabled="
              Object.keys(formattedPaidBillItems).length > 0 ? false : true
            "
            @click="exportToPDF(true)"
            md="0"
            :loading="loadingTable"
            type="submit"
          >
            <i class="no no-floppy-disk"></i>Exportar PDF</b-dropdown-item
          >
          <b-dropdown-item
            v-if="!loadingTable && withdrawMode"
            @click="saveWithdraw()"
            md="0"
            :loading="loadingTable"
            type="submit"
          >
            <i class="fas fa-file-signature"></i>Registrar
            retirada</b-dropdown-item
          >
        </b-dropdown>
      </template>

      <base-header v-if="!hideWhilePrintingPDF" class="pb-6">
        <b-row align-h="start" align-v="center" class="mb-4">
          <b-col align-self="start" sm="6" md="2" class="mb-1">
            <date-picker
              v-model="formDate.startDate"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              class="w-100"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </date-picker>
          </b-col>

          <b-col align-self="start" md="2" sm="6" class="mb-1">
            <date-picker
              v-model="formDate.endDate"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              class="w-100"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </date-picker>
          </b-col>

          <b-col class="text-left col-2">
            <base-button
              @click="loadReport"
              :disabled="!formDate.startDate || !formDate.endDate"
              :loading="loadingTable"
              type="submit"
              class="btn btn-outline-info"
            >
              Filtrar
            </base-button>
          </b-col>
        </b-row>
      </base-header>

      <b-container fluid class="mt--6">
        <div class="pdf-item">
          <b-row>
            <b-col v-if="!hideWhilePrintingPDF" xl="12">
              <!-- CARD ULTIMAS RETIRADAS -->
              <b-card
                footer-classes="pb-2"
                style="max-height: 335px; overflow-y: auto"
                v-if="withdrawMode"
              >
                <template v-slot:header>
                  <b-row>
                    <b-col cols="12">
                      <h5 class="h3 mb-0">Últimas retiradas</h5>
                      <b-button
                        @click="openModalInfoRelatorio"
                        :disabled="blockWithdrawBtn"
                        size="sm"
                        variant="success"
                        >Saldo Maquininha</b-button
                      >
                    </b-col>
                  </b-row>
                </template>

                <div>
                  <b-table
                    :items="formattedWithdraws"
                    :fields="fieldsBookings"
                    sort-by="month"
                    :sortDesc="true"
                    empty-text="Não há Retiradas registradas."
                    show-empty
                    small
                  >
                    <!-- mes ref -->
                    <template #cell()="data">
                      {{
                        data.item.period.start
                          ? new Date(
                              data.item.period.start + ' 12:00:00'
                            ).getDate() + ' a '
                          : '--'
                      }}
                      {{
                        data.item.period.end
                          ? new Date(
                              data.item.period.end + ' 12:00:00'
                            ).getDate()
                          : ''
                      }}
                      {{
                        data.item.period.end
                          ? (
                              '0' +
                              (new Date(
                                data.item.period.end + ' 12:00:00'
                              ).getMonth() +
                                1)
                            ).slice(-2)
                          : ''
                      }}/{{
                        data.item.period.end
                          ? new Date(
                              data.item.period.end + ' 12:00:00'
                            ).getFullYear()
                          : ''
                      }}
                    </template>

                    <!-- solicitação -->
                    <template #cell(date_solicitacao)="data">
                      {{ new Date(data.value).toLocaleString('pt-BR') }}
                    </template>

                    <template #cell(value)="data">
                      {{
                        data.value == '--'
                          ? data.value
                          : 'R$ ' +
                            data.value
                              .toFixed(2)
                              .toLocaleString('pt-BR')
                              .replace('.', ',')
                      }}
                    </template>

                    <!-- <template #cell(vendor_tax)="data">
                    {{ 'R$ ' + data.value }}
                  </template> -->

                    <template #cell(status)="data">
                      {{ data.value }}
                    </template>

                    <template #cell(download)="data">
                      <base-button
                        @click="downloadWithdrawReport(data.item.id)"
                        :disabled="loadingTable == true"
                        size="sm"
                        icon
                        variant="secondary"
                      >
                        <i class="fas fa-download"></i>
                      </base-button>

                      <base-button
                        @click="selectWithdrawReport(data.item.id)"
                        :disabled="loadingTable == true"
                        size="sm"
                        icon
                        variant="secondary"
                        :class="`${
                          indexedReport != null &&
                          data.item.id == indexedReport.id
                            ? 'bg-success'
                            : ''
                        }`"
                      >
                        <i class="fas fa-check"></i>
                      </base-button>
                    </template>
                  </b-table>
                </div>
              </b-card>
            </b-col>
            <!-- FIM CARD ULTIMAS RETIRADAS -->

            <b-col xl="4" md="4">
              <!-- CARD Arrecadação no periodo -->
              <b-card body-class="px-0">
                <template v-slot:header>
                  <b-row align-h="between">
                    <b-col>
                      <h5 class="h3 mb-0">Consolidado</h5>
                    </b-col>
                  </b-row>
                </template>

                <div
                  class="ml-4 d-flex mr-4"
                  style="color: dimgrey"
                  v-if="fetchProgress == 0"
                >
                  <i class="mt-2 no no-lg no-file-text-3"></i>
                  <h4
                    class="text-black mb-0 ml-3"
                    style="font-weight: 400; color: dimgrey"
                  >
                    Selecione um período para visualizar um resumo das
                    estatísiticas de venda.
                  </h4>
                </div>

                <div v-if="fetchProgress == 100" class="ml-3 mr-3">
                  <b-table
                    :items="infoBookingsByVendor"
                    v-show="formattedPaidBillItems.length"
                    :fields="fieldsRetiradaImpressao"
                    stacked
                    show-empty
                    empty-text="Não há informações disponíveis."
                  >
                    <template #cell(period)="data">
                      {{ data.value }} {{ data.value > 1 ? 'dias' : 'dia' }}
                    </template>

                    <template #cell(bill_items_count)="data">
                      {{ data.value }} {{ data.value > 1 ? 'pagas' : 'paga' }}
                    </template>

                    <template #cell(visitors)="data">
                      {{ data.value.total }}
                      {{ data.value.total > 1 ? 'pessoas' : 'pessoa' }} ({{
                        data.value.paying
                      }}
                      {{ data.value.paying > 1 ? 'pagantes' : 'pagante' }})
                    </template>

                    <template #cell(no_show)="data">
                      {{ data.value }} vagas
                    </template>

                    <template #cell(local_total)="data">
                      R$ {{ data.value }}
                    </template>

                    <template #cell(curr_pos)="data">
                      R$
                      {{
                        data.value
                          .toFixed(2)
                          .toLocaleString('pt-BR')
                          .replace('.', ',')
                      }}
                    </template>

                    <template #cell(online_total)="data">
                      <span v-if="!hideWhilePrintingPDF">
                        <i
                          title="Saldo em vendas à vista (pix, débito e carteira) no período selecionado"
                          class="fa fa-info-circle"
                        ></i>
                      </span>

                      R$
                      {{
                        data.value
                          .toFixed(2)
                          .toLocaleString('pt-BR')
                          .replace('.', ',')
                      }}
                    </template>

                    <template #cell(online_total_byday)="data">
                      R$
                      {{
                        (data.item.online_total / totalDays)
                          .toFixed(2)
                          .toLocaleString('pt-BR')
                          .replace('.', ',')
                      }}/dia
                    </template>

                    <template #cell(taxa_adm)="data">
                      R$ {{ data.value }}
                    </template>

                    <template #cell(total_transfer)="data">
                      <b
                        >R$
                        {{
                          data.value
                            .toFixed(2)
                            .toLocaleString('pt-BR')
                            .replace('.', ',')
                        }}</b
                      >
                    </template>

                    <template #cell(curr_period_total_cred)="data">
                      <i
                        v-if="!hideWhilePrintingPDF"
                        class="fa fa-info-circle"
                        title="Saldo em vendas a crédito no período selecionado. Este valor será transferido no repasse de mesmo período do mês seguinte"
                      ></i>
                      R$
                      {{
                        data.value
                          .toFixed(2)
                          .toLocaleString('pt-BR')
                          .replace('.', ',')
                      }}
                    </template>

                    <template #cell(last_period_total_cred)="data">
                      <i
                        v-if="!hideWhilePrintingPDF"
                        title="Saldo em vendas a crédito no último período"
                        class="fa fa-info-circle"
                      ></i>
                      R$
                      {{
                        data.value
                          .toFixed(2)
                          .toLocaleString('pt-BR')
                          .replace('.', ',')
                      }}
                    </template>
                  </b-table>
                </div>
              </b-card>
            </b-col>
            <!-- FIM CARD INFO RETIRADAS -->

            <b-col xl="4" md="4">
              <!--SEÇÃO por forma de pagamento-->
              <b-card>
                <template slot="header">
                  <b-row align-h="between">
                    <b-col>
                      <h3 class="mb-0">Arrecadação por forma de pagamento</h3>
                    </b-col>
                  </b-row>
                </template>

                <div class="d-flex" v-if="fetchProgress == 0">
                  <i
                    class="mt-1 no no-lg no-database"
                    style="color: dimgrey"
                  ></i>
                  <h4
                    class="mb-0 ml-3"
                    style="font-weight: 400; color: dimgrey"
                  >
                    Selecione um período para visualizar um gráfico das
                    arrecadações por forma de pagamento.
                  </h4>
                </div>

                <doughnut-chart-pagamento
                  v-if="fetchProgress == 100"
                  :height="250"
                  :formattedPaidBillItems="formattedPaidBillItems"
                  :totalPaidValue="totalPaidValue"
                  :fetchProgress="fetchProgress"
                  :dataTableByPaymentMethod="dataTableByPaymentMethod"
                  :hideDoughnut="hideDoughnuts"
                  :hideWhilePrintingPDF="hideWhilePrintingPDF"
                  :colors="colors"
                >
                </doughnut-chart-pagamento>
              </b-card>
            </b-col>

            <b-col xl="4" md="4">
              <b-card>
                <template slot="header">
                  <b-row align-h="between">
                    <b-col>
                      <h3 class="mb-0">Arrecadação por tipo de ingresso</h3>
                    </b-col>
                  </b-row>
                </template>

                <div class="d-flex" v-if="fetchProgress == 0">
                  <i
                    class="mt-1 no no-lg no-database"
                    style="color: dimgrey"
                  ></i>
                  <h4
                    class="mb-0 ml-3"
                    style="font-weight: 400; color: dimgrey"
                  >
                    Selecione um período para visualizar um gráfico das
                    arrecadações por tipo de ingresso.
                  </h4>
                </div>

                <div v-if="fetchProgress == 100">
                  <doughnut-chart-ingresso
                    v-if="Object.keys(formattedPaidBillItems).length > 0"
                    :height="250"
                    :colors="colors"
                    :hideWhilePrintingPDF="hideWhilePrintingPDF"
                    :hideDoughnut="hideDoughnuts"
                    :filteredPersonTypes="filteredPersonTypes"
                    :fetchProgress="fetchProgress"
                  >
                  </doughnut-chart-ingresso>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </div>
        <!--FIM SEÇÃO ÚLtimas Retiradas -->

        <div class="pdf-item pdf-new-page">
          <!-- Início SEÇÃO GRÁFICO VISITAÇAO -->
          <b-row>
            <b-col class="col-12">
              <b-card>
                <template slot="header">
                  <b-row align-h="between">
                    <b-col>
                      <h3 class="mb-0">Arrecadação por dia</h3>
                    </b-col>
                  </b-row>
                </template>

                <div class="d-flex" v-if="fetchProgress == 0">
                  <i
                    class="mt-1 no no-lg no-database"
                    style="color: dimgrey"
                  ></i>
                  <h4
                    class="mb-0 ml-3"
                    style="font-weight: 400; color: dimgrey"
                  >
                    Selecione um período para visualizar um gráfico das
                    arrecadações por dia.
                  </h4>
                </div>

                <b-row>
                  <b-col cols="12" style="overflow-x: auto" class="col-12">
                    <bar-chart-arrecadacao
                      v-if="fetchProgress == 100"
                      :height="250"
                      style="max-height: 100%"
                      :colors="colors"
                      :hideWhilePrintingPDF="hideWhilePrintingPDF"
                      :formattedPaidBillItems="formattedPaidBillItems"
                      @legendaChartArrecadacao="getLegendaChartArrecadacao"
                      :fetchProgress="fetchProgress"
                      @changeUseChartCache="changeUseChartCache"
                    >
                    </bar-chart-arrecadacao>
                  </b-col>
                </b-row>

                <b-row v-if="hideWhilePrintingPDF" class="pdf-item">
                  <!-- APARECE APENAS NA IMPRESSÃO DO RELATÓRIO DE VENDAS -->
                  <b-col class="col-12">
                    <legenda-chart-arrecadacao
                      :legendaChartArrecadacao="legendaChartArrecadacao"
                      :hideWhilePrintingPDF="hideWhilePrintingPDF"
                    ></legenda-chart-arrecadacao>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </div>
        <!-- fim SEÇÃO GRÁFICO VISITAÇAO -->

        <modal-tabela-reservas
          :showModalTabelaReservas="showModalTabelaReservas"
          :hideWhilePrintingPDF="hideWhilePrintingPDF"
          :transformedItemsArray="transformedItemsArray"
          @emitCloseModalTabelaReservas="closeModalTabelaReservas"
        >
        </modal-tabela-reservas>

        <div v-if="hideWhilePrintingPDF" class="pdf-item pb-6">
          <footer-relatorio :obs="infoRelatorio.obs"></footer-relatorio>
        </div>

        <!--
        formulas para o relatório gerencianet
        ="Crédito: "&SUMIF(C:C;"=Crédito";D:D)
        ="Débito: "&SUMIF(C:C;"=Débito";D:D)
        ="PIX: "&SUMIF(C:C;"=PIX";D:D)
        =SUMIF(C:C;"=Débito";D:D)+SUMIF(C:C;"=PIX";D:D)
       -->
        <b-modal
          v-model="showModalRelatorio"
          centered
          size="sm"
          hide-footer
          static
        >
          <template #modal-header>
            <h2 align-v="start" class="card-header w-100">Retirada de Saldo</h2>

            <slot name="modal-header-close">
              <button
                type="button"
                class="close"
                @click="showModalRelatorio = false"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span @click="showModalRelatorio = false">x</span>
              </button>
            </slot>
          </template>

          <div>
            <div v-if="isFetchBillsInProgress">
              <modal-loading
                :openModal="isFetchBillsInProgress"
                :value="fetchProgress"
                :label="'Gerando Relatório... ' + fetchProgress + '%'"
              >
              </modal-loading>
            </div>

            <div v-else>
              <b-form-group>
                <b-row align-h="center">
                  <b-col cols="12">
                    <span class="demonstration h4">Mês referência</span>
                    <date-picker
                      v-model="infoRelatorio.month"
                      type="month"
                      format="MM/yyyy"
                      value-format="yyyy-MM"
                      :disabled-date="verifyDisabledDates.verifyDisabledDates"
                      class="w-100 mb-1"
                      :clearable="false"
                      placeholder="Selecione"
                      label="Mês no qual as vendas aconteceram"
                    >
                    </date-picker>
                  </b-col>
                </b-row>

                <b-row align-h="center">
                  <b-col cols="12">
                    <base-input
                      v-model="infoRelatorio.posCreditCurrentMonth"
                      type="text"
                      label="Crédito (Máquina de cartão)"
                      name="creditCurrent"
                    ></base-input>
                  </b-col>
                </b-row>

                <b-row align-h="center">
                  <b-col cols="12">
                    <base-input
                      v-model="infoRelatorio.posDebitCurrentMonth"
                      type="text"
                      label="Débito (Máquina de cartão)"
                      name="creditCurrent"
                    ></base-input>
                  </b-col>
                </b-row>

                <b-row align-h="center">
                  <b-col cols="12">
                    <base-input
                      v-model="infoRelatorio.posPixCurrentMonth"
                      type="text"
                      label="Pix (Máquina de cartão)"
                      name="pixCurrent"
                    ></base-input>
                  </b-col>
                </b-row>

                <b-row align-h="center">
                  <b-col cols="12">
                    <base-input label="Observação">
                      <textarea
                        v-model="infoRelatorio.obs"
                        name="obs"
                        class="form-control w-100"
                        rows="3"
                      >
                      </textarea>
                    </base-input>
                  </b-col>
                </b-row>
              </b-form-group>
            </div>
          </div>

          <template #modal-footer>
            <div>
              <b-row align-h="end">
                <b-col>
                  <base-button
                    @click="
                      filterSelectedRowsToWithdraw()
                      showModalRelatorio = false
                    "
                    :disabled="isFetchBillsInProgress"
                    size="sm"
                    type="primary"
                    icon
                    >Salvar
                  </base-button>
                </b-col>
              </b-row>
            </div>
          </template>
        </b-modal>
      </b-container>
    </dashboard-page>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  Tabs,
  TabPane,
  DropdownMenu,
} from 'element-ui'
import store from '@/store'
import { BasePagination } from '@/components'
import swal from 'sweetalert2'
import nodeService from '../../services/nodejs/index'
import { DatePicker } from 'element-ui'
import BaseButton from '../../components/BaseButton.vue'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import html2pdf from 'html2pdf.js'
import moment from 'moment'
import 'jspdf-autotable'
import colors from '@/store/utils/colors'
import { mapActions, mapGetters } from 'vuex'
import Modal from '@/components/Modal'
import DoughnutChartPagamento from './Charts/DoughnutChartPagamento.vue'
import BarChartArrecadacao from './Charts/BarChartArrecadacao.vue'
import DoughnutChartIngresso from './Charts/DoughnutChartIngresso.vue'
import LegendaChartArrecadacao from './Impressao/LegendaChartArrecadacao.vue'
import HeaderRelatorio from './Impressao/HeaderRelatorio.vue'
import FooterRelatorio from './Impressao/FooterRelatorio.vue'
import ModalTabelaReservas from './ModalTabelaReservas.vue'

export default {
  component: 'SalesReport',

  components: {
    DatePicker,
    BasePagination,
    BaseButton,
    colors,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    BarChartArrecadacao,
    DoughnutChartPagamento,
    DoughnutChartIngresso,
    LegendaChartArrecadacao,
    HeaderRelatorio,
    FooterRelatorio,
    Modal,
    store,
    ModalLoading,
    ModalTabelaReservas,
  },

  data: () => {
    return {
      todayReferenceDate: '',
      formDate: { startDate: null, endDate: null },
      useFakeData: false,
      loadingTableByPaymentMethod: false,
      activeName: 'second',
      loadingTable: false,
      tableColumns: [],
      hideWhilePrintingPDF: false,

      verifyDisabledDates: {
        verifyDisabledDates() {
          const datesToBlock = Object.keys(this.withdrawCCList)
          const lastMonth = datesToBlock[0]
          return datesToBlock.includes(date)
        },
      },

      pickerOptions: {
        disabledDate(date) {
          let limitedPlacesReport = [
            // '5662C894-ABAE-11EC-8BF6-F23C9227EC8D', //Prefeitura Municipal de Lençóis
            // '2F249056-A778-11EB-9702-5254006CC309', //Prefeitura Municipal de Ibicoara
            // '481E9F40-4B07-11ED-8534-F23C9227EC8D', //Prefeitura Municipal de Mucugê
            // '2F2BCB3C-A778-11EB-9702-5254006CC309', //Baixio Turismo
            // '6FEFDE5F-A2BF-11EF-8851-F23C954BFE7D', //Aldeia Kaí
            // '6A86211A-A2C2-11EF-8851-F23C954BFE7D', //Reserva Pataxó Porto do Boi
            // '7D4B3A93-1719-11EE-8426-F23C9227EC8D', //Prefeitura Municipal de Iraquara
            // 'D012702C-A6EF-11EF-8851-F23C954BFE7D', //Aldeia Gurita
            // '191318F3-A6ED-11EF-8851-F23C954BFE7D', //Aldeia Tibá
            // '14415C12-7CFF-11EF-8851-F23C954BFE7D', //Concessionária SerraMar
            '2F24D331-A778-11EB-9702-5254006CC309', //Parque Nacional da Chapada Diamantina
            // '3342CF7A-1BD5-11EC-9702-5254006CC309', //Complexo Arqueológico Serra das Paridas
            // 'AF61D419-56CB-11ED-8534-F23C9227EC8D', //Fazenda Akã
            // 'E6A15CA6-56EF-11ED-8534-F23C9227EC8D', //Vinícola Vaz
            // 'A3B13D25-6C5B-11EE-8426-F23C9227EC8D', //Ecoparque Pedra da Arara
            // '586D54E3-8327-11EE-8426-F23C9227EC8D', //Gruta da Marota
            // 'CA0359E0-AB40-11EE-8426-F23C9227EC8D', //Tirolesa Buracão
            // 'DC26661A-46C7-11EF-8426-F23C9227EC8D', //Museu Sincorá
            'D488F20F-E989-42AC-81BA-8E5747985ACD', //Pedra da Arara
          ]
          var firstDayOf2024 = moment('2024-01-01')
          if (
            limitedPlacesReport.indexOf(store.getters['auth/user'].placeUuid) >=
            0
          ) {
            firstDayOf2024 = moment('2020-11-01')
          }
          return moment(date).isBefore(firstDayOf2024)
        },
      },

      /**
       * conjunto principal de reservas considerado no relatório.
       * Esse array é criado a partir da formatação das vendas (Bills) recuperadas do service (cake ou node).
       *
       */
      selectedRows: [],
      noCheckinCount: 0,

      //withdraw objetct to be created and sended to backend
      withdraw: {},

      //withdraw's list of logged user
      withdrawList: [],

      //withdraw list with credit card payments
      withdrawCCList: {},

      //Bookings or Bocapio Bill items
      totalsPersonsTypes: {},

      //selected report from withdrawList
      indexedReport: null,

      legendaChartArrecadacao: [],

      showModalRelatorio: false,
      showModalTabelaReservas: false,

      fieldsBookings: [
        { key: 'period', label: 'Referência' },
        { key: 'date_solicitacao', label: 'Data de Solicitação' },
        { key: 'value', label: 'Saldo' },
        // { key: 'vendor_tax', label: 'Tx Op Financeira' },
        { key: 'status', label: 'Status' },
        // { key: 'date_proccessed', label: 'Data de Processamento' },
        { key: 'download', label: '' },
      ],

      fieldsRetirada: [
        // { key: 'pedidos', label: 'Pedidos' },
        { key: 'period', label: 'Período', title: 'Período do retlatório' },
        { key: 'bill_items_count', label: 'Reservas', visible: false },
        { key: 'visitors', label: 'Pessoas' },
        { key: 'no_show', label: 'Desistentes', visible: false },
        { key: 'visitors_by_day', label: 'Pessoas por dia', visible: false },
        { key: 'local_total', label: 'Venda Local (anotada)', visible: false },
        { key: 'online_total', label: 'Saldo em vendas à vista (site)' },
        {
          key: 'online_total_byday',
          label: 'Saldo em vendas à vista (site)/dia',
          visible: false,
        },
        { key: 'taxa_adm', label: 'Tx Op Financeira', visible: false },
        // { key: 'last_period_pos', label: 'Venda POS anterior', title:'Saldo em vendas via maquininha no último período', visible: false },
        {
          key: 'curr_pos',
          label: 'Saldo em vendas à vista (maquininha)',
          title: 'Saldo em vendas via maquininha no período selecionado',
          visible: true,
        },
        {
          key: 'last_period_total_cred',
          label: '*Saldo em vendas a crédito (anterior)',
          visible: false,
        },
        {
          key: 'curr_period_total_cred',
          label: '**Vendas a crédito neste período',
          title:
            'Valore pagos com cartão de crédito são repassados após a compensação (30 dias)',
          visible: true,
        },
        { key: 'total_transfer', label: 'Saldo a receber', visible: true },
      ],
      //Report in mod to generate withdraw
      withdrawMode: false,

      billsMemBuffer: [],
      //value of fetchBills progress
      fetchProgress: 0,

      //vendor tax. if no poi has tax, it will bill setted to 0
      global_vendor_tax: 0.1,

      hideDoughnuts: false,

      //handle only checkedin bookings
      checkedinOnly: true,

      //test withdraw
      checkWithdraw: false,

      withdraw_test: { bookings: [] },
    }
  },

  props: {
    itemLimit: {
      type: Number,
      default: 10,
    },
  },

  mounted() {
    if (this.todayReferenceDate) {
      this.formDate.startDate = this.todayReferenceDate
      this.formDate.endDate = this.todayReferenceDate
    }

    if (
      process.env.NODE_ENV !== 'production' ||
      this.$route.query.debug == 'true'
    ) {
      window.jdebug = this
    }
    if (this.$route.query.checkin == 'no_checkin') {
      this.checkedinOnly = false
    }
    if (this.$route.query.withdraw == 'check') {
      this.checkWithdraw = true
    }

    const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
    this.fetchPOIs({ PLACE_UUID: PLACE_UUID, PRODUCT_UUID: '' })
    this.fetchWithdraws()

    if (this.$route.query.mode == 'retirada') {
      this.setFieldsToPrint('curr_pos', true)
      this.setFieldsToPrint('last_period_total_cred', true)
      this.setFieldsToPrint('total_transfer', true)
      this.withdrawMode = true
      this.hideDoughnuts = true
    }
  },

  computed: {
    ...mapGetters('auth', {
      user: 'user',
      place: 'getPlace',
      params: 'params',
    }),

    ...mapGetters('report', {
      isFetchBillsInProgress: 'getFetchBillsInProgress',
      requestArrayStatus: 'getRequestArrayStatus',
      transformedItems: 'getBookings',
      useChartCache: 'getUseChartCache',
    }),

    ...mapGetters('product', {
      pois: 'getPois',
    }),

    ...mapGetters('operacao', {
      bookingPaidStatus: 'getBookingPaidStatusArray',
      paymentMethodsAliases: 'getPaymentMethodsAliases',
    }),

    datasMesRelatorio() {
      var month = moment(this.infoRelatorio.month)
      const sDate = month.startOf('month').format('YYYY-MM-DD')
      const eDate = month.endOf('month').format('YYYY-MM-DD')

      return { sDate: sDate, eDate: eDate }
    },

    fieldsRetiradaImpressao() {
      return this.fieldsRetirada.filter((e) => e.visible != false)
    },

    colors() {
      return colors.colors
    },

    blockWithdrawBtn() {
      var today = new Date()

      if (this.formattedWithdraws.length > 0) {
        if (this.formattedWithdraws.length > 1) {
          var lastWithdraw = this.formattedWithdraws.reduce(function (
            prev,
            current
          ) {
            return new Date(prev.date_solicitacao) >
              new Date(current.date_solicitacao)
              ? prev
              : current
          })

          lastWithdraw = lastWithdraw.date_solicitacao
        } else {
          var lastWithdraw = new Date(
            this.formattedWithdraws[0].date_solicitacao
          )
        }

        // CHANGE FIRST CONDIT. RESULT TO TRUE LATER
        return today.getMonth() == new Date(lastWithdraw).getMonth() &&
          today.getFullYear() == new Date(lastWithdraw).getFullYear()
          ? false
          : false
      } else {
        return false
      }
    },

    infoBookingsByVendor() {
      if (this.fetchProgress > 0 && this.fetchProgress < 100) {
        return [
          {
            period: 0,
            bill_items_count: 0,
            visitors: { total: 0, paying: 0, types: [] },
            no_show: 0,
            visitors_by_day: 0,
            online_total: 0,
            local_total: 0,
            curr_pos: 0,
            taxa_adm: 0,
            total_transfer: 0,
            last_period_total_cred: 0,
            curr_period_total_cred: 0,
          },
        ]
      } else if (this.fetchProgress == 0 || this.fetchProgress == 100) {
        let curr_pos_pix = this.infoRelatorio.posPixCurrentMonth / 1
        curr_pos_pix -= curr_pos_pix * this.global_vendor_tax

        let curr_pos_deb = this.infoRelatorio.posDebitCurrentMonth / 1
        curr_pos_deb -= curr_pos_deb * this.global_vendor_tax

        let online_total = this.withdraw.data
          ? this.withdraw.data.info.online_deb +
            this.withdraw.data.info.online_pix +
            this.withdraw.data.info.online_wallet
          : 0
        let last_period_total_cred = this.indexedReport
          ? this.indexedReport.online_cred / 1
          : 0

        let _total_transfer = online_total

        if (this.withdraw.data.info.localpm['debit'] == undefined) {
          _total_transfer += curr_pos_deb
        }

        if (this.withdraw.data.info.localpm['pix'] == undefined) {
          _total_transfer += curr_pos_pix
        }

        if (this.withdraw.data.info.localpm['credit'] == undefined) {
          last_period_total_cred += this.indexedReport
            ? this.indexedReport.pos_cred / 1
            : 0
        }

        _total_transfer += last_period_total_cred

        if (this.indexedReport) {
          return [
            {
              period: this.totalDays,
              bill_items_count: this.formattedPaidBillItems.length,
              visitors: {
                total: this.totalsPersonsCount,
                paying: this.payingPersonsCount,
                types: this.filteredPersonTypes,
              },
              no_show: this.noCheckinCount,
              visitors_by_day: (this.totalsPersonsCount / this.totalDays)
                .toFixed(2)
                .replace('.', ','),
              // online_total: (this.indexedReport.online_pix + this.indexedReport.online_wallet),
              online_total: online_total,
              local_total: this.totalLocalPaidBillItems,
              // last_period_pos: last_period_pos,
              curr_pos: curr_pos_pix + curr_pos_deb,
              taxa_adm: this.indexedReport.vendor_tax,
              total_transfer: _total_transfer,
              last_period_total_cred: last_period_total_cred,
              curr_period_total_cred: this.withdraw.data
                ? this.withdraw.data.info.pos_cred / 1 +
                  this.withdraw.data.info.online_cred / 1
                : 0,
            },
          ]
        } else {
          if (this.withdraw.data) {
            return [
              {
                period: this.totalDays,
                bill_items_count: this.formattedPaidBillItems.length,
                visitors: {
                  total: this.totalsPersonsCount,
                  paying: this.payingPersonsCount,
                  types: this.filteredPersonTypes,
                },
                no_show: this.noCheckinCount,
                visitors_by_day: (this.totalsPersonsCount / this.totalDays)
                  .toFixed(2)
                  .replace('.', ','),
                online_total: online_total,
                local_total: this.totalLocalPaidBillItems,
                // last_period_pos: last_period_pos,
                curr_pos: curr_pos_pix + curr_pos_deb,
                taxa_adm: 0,
                total_transfer: _total_transfer,
                last_period_total_cred: last_period_total_cred,
                curr_period_total_cred: this.withdraw.data
                  ? this.withdraw.data.info.pos_cred / 1 +
                    this.withdraw.data.info.online_cred / 1
                  : 0,
              },
            ]
          }
        }
      }
    },

    totalDays() {
      return (
        moment(this.formDate.endDate).diff(
          moment(this.formDate.startDate),
          'days'
        ) + 1
      )
    },

    transformedItemsArray() {
      const vm = this
      vm.noCheckinCount = 0
      return Array.prototype.concat.apply(
        [],

        this.transformedItems.filter(function (value, index) {
          if (value.checkin.hasCheckin !== true) {
            vm.noCheckinCount += value.people.tableText.count
          }
          if (
            value.status &&
            vm.bookingPaidStatus.indexOf(value.status.toUpperCase()) >= 0
          ) {
            // console.log(value.checkin.hasCheckin === true? value.code + ' com checkin':value.code+ '   <<< SEM CHECKIN ',(vm.checkedinOnly?' CHECKEDIN ONLY':' ALL BOOKINGS'))
            //apenas reservas pagas e com checkin
            if (
              (vm.checkedinOnly === true &&
                value.checkin.hasCheckin === true) ||
              vm.checkedinOnly === false
            ) {
              return value
            }
          }
        })
      )
    },

    formattedPaidBillItems() {
      const vm = this
      return this.transformedItemsArray.filter(function (value, index) {
        if (
          value.status &&
          vm.bookingPaidStatus.indexOf(value.status.toUpperCase()) >= 0
        ) {
          return value
        }
      })
    },

    unpaidFormattedBillItems() {
      const vm = this
      if (this.transformedItemsArray.length > 0) {
        return this.transformedItemsArray.filter(function (value, index) {
          if (
            value.status &&
            vm.bookingPaidStatus.indexOf(value.status.toUpperCase()) >= 0
          ) {
            return value
          }
        })
      } else {
        return []
      }
    },

    totalUnpaidBillItems() {
      if (this.unpaidFormattedBillItems.length > 0) {
        return this.unpaidFormattedBillItems
          .map(function (value, idx) {
            return value.finalValue
          })
          .reduce((prev, curr) => prev + curr, 0)
      } else {
        return 0
      }
    },

    payingPersonsCount() {
      var person_counts = 0

      if (this.transformedItemsArray.length > 0) {
        person_counts = this.transformedItemsArray
          .map(function (value, index) {
            if (value.paymentMethod != 'pos_cortesia') {
              let bookingFreePass = Object.keys(value.itemPersonType)
                .map((item) =>
                  item.toLowerCase() == 'cortesia'
                    ? value.itemPersonType[item]['count']
                    : 0
                )
                .reduce((prev, curr) => prev + curr, 0)

              return value.people.tableText.count - bookingFreePass
            }
          })
          .filter((value) => value)
          .reduce((prev, curr) => prev + curr, 0)
      } else {
        person_counts = 0
      }

      return person_counts
    },

    totalsPersonsCount() {
      var person_counts = 0

      if (this.transformedItemsArray.length > 0) {
        person_counts = this.transformedItemsArray
          .map(function (value, index) {
            return value.people.tableText.count
          })
          .reduce((prev, curr) => prev + curr, 0)
      } else {
        person_counts = 0
      }

      return person_counts
    },

    totalPaidValue() {
      var total_paid_value = 0.0
      const vm = this

      if (this.formattedPaidBillItems.length > 0) {
        total_paid_value = this.formattedPaidBillItems
          .map(function (value, index) {
            //DONE: use payments.foreach
            if (
              value.status &&
              vm.bookingPaidStatus.indexOf(value.status.toUpperCase()) >= 0 &&
              value.paymentMethod != 'pos_cortesia'
            ) {
              return new Number(value.finalValue)
            }
          })
          .filter((el) => el != undefined)
          .reduce((prev, curr) => prev + curr, 0.0)
      } else {
        total_paid_value = 0.0
      }
      return total_paid_value
    },

    totalLocalPaidBillItems() {
      var total_local_paid_bill_items = 0

      if (this.formattedPaidBillItems.length > 0) {
        total_local_paid_bill_items = this.formattedPaidBillItems
          .map(function (value, index) {
            //DONE: use payments.foreach
            var payment_method = value.paymentMethod
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')

            if (
              (value.paymentMethod && payment_method == 'local') ||
              value.confirmPayment.hasLocalPayment
            ) {
              return value.finalValue
            }
          })
          .filter((el) => el != undefined)
          .reduce((prev, curr) => prev + curr, 0)
      } else {
        total_local_paid_bill_items = 0
      }

      return total_local_paid_bill_items
    },

    dataTableByPaymentMethod() {
      let paymentMethodsAliases = JSON.parse(
        JSON.stringify(this.paymentMethodsAliases)
      )
      this.formattedPaidBillItems.map((billItem) => {
        //DONE: use payments.foreach
        let paymentMethod = billItem.paymentMethod

        if (billItem.channel == 'POSCONTROLE') {
          billItem.payments.forEach((payment) => {
            let payment_pos_type =
              payment.data_origin.TEFType || payment.data_origin.Name

            switch (payment_pos_type) {
              case '01':
                paymentMethod = 'pos_debit'
                break
              case '02':
                paymentMethod = 'pos_credit'
                break
              case '06':
                paymentMethod = 'pos_pix'
                break
              case 'Dinheiro':
                paymentMethod = 'pos_dinheiro'
                break
              case 'Cortesia':
                paymentMethod = 'pos_cortesia'
                break
              default:
                paymentMethod = 'unknown'
            }

            paymentMethodsAliases[paymentMethod.toUpperCase()]['value'] +=
              new Number(payment.payment_value)
          })
        } else if (billItem.finalValue) {
          if (
            billItem.payments[0].payment_description
              .toUpperCase()
              .indexOf('WALLET') == 0
          ) {
            paymentMethod = 'wallet'
          }
          paymentMethodsAliases[paymentMethod.toUpperCase()]['value'] +=
            new Number(billItem.finalValue)
          paymentMethodsAliases[paymentMethod.toUpperCase()]['percentage'] = 0
        }
      })

      return Object.fromEntries(
        Object.entries(paymentMethodsAliases).filter(
          (alias) => alias[1].value > 0
        )
      )
    },

    infoRelatorio() {
      if (this.formattedPaidBillItems.length > 0) {
        var month =
          this.formDate.startDate == null
            ? moment().format('YYYY-MM')
            : this.formDate.startDate.substring(0, 7)
        var infoRelatorio = {
          posDebitCurrentMonth: 0.0,
          posCreditCurrentMonth: 0.0,
          posPixCurrentMonth: 0.0,
          month: month,
        }

        this.formattedPaidBillItems.map(function (value, index) {
          //TODO: use payments.foreach
          //DONE: use payments.foreach
          let paymentMethod = value.paymentMethod

          if (value.channel == 'POSCONTROLE') {
            value.payments.forEach((payment) => {
              let payment_pos_type =
                payment.data_origin.TEFType || payment.data_origin.Name

              switch (payment_pos_type) {
                case '01':
                  paymentMethod = 'pos_debit'
                  infoRelatorio.posDebitCurrentMonth += Number(
                    payment.payment_value
                  )
                  break
                case '02':
                  paymentMethod = 'pos_credit'
                  infoRelatorio.posCreditCurrentMonth += Number(
                    payment.payment_value
                  )
                  break
                case '06':
                  paymentMethod = 'pos_pix'
                  infoRelatorio.posPixCurrentMonth += Number(
                    payment.payment_value
                  )
                  break
                case 'Dinheiro':
                  paymentMethod = 'pos_dinheiro'
                  break
                case 'Cortesia':
                  paymentMethod = 'pos_cortesia'
                  break
                default:
                  paymentMethod = 'unknown'
              }
            })
          }
        })

        return infoRelatorio
      }
      return {
        posDebitCurrentMonth: 0.0,
        posCreditCurrentMonth: 0.0,
        posPixCurrentMonth: 0.0,
        month: '',
        obs: '',
      }
    },

    filteredPersonTypes() {
      var total_persons = []
      let total_persons_types = { inteira: 0, meia: 0, cortesia: 0 }

      this.formattedPaidBillItems.map(function (billItem, idx) {
        //TODO: use payments.foreach
        Object.keys(billItem.itemPersonType).forEach((person_type) => {
          let _person_type = person_type.toLowerCase()

          if (_person_type == 'meia') {
            _person_type = 'meia entrada'
          }

          if (total_persons_types[_person_type] == undefined) {
            total_persons_types[_person_type] = 0
          }

          if (billItem.paymentMethod === 'pos_cortesia') {
            total_persons_types['cortesia'] +=
              billItem.itemPersonType[person_type]['count']
          } else {
            total_persons_types[_person_type] +=
              billItem.itemPersonType[person_type]['count']
          }
          var persons = billItem.itemPersonType[person_type]['count']
          total_persons.push({ cost: billItem.finalValue, persons: persons })
        })
      })
      return total_persons_types
    },

    /**
     * monta a tabela de retiradas
     */
    formattedWithdraws() {
      this.withdrawCCList = {}
      const vm = this

      this.withdrawList.map(function (val) {
        let orders = JSON.parse(val.orders)[0]
        vm.withdrawCCList[orders.info.period.start] = {
          pos: orders.info.pos_cred,
          online: orders.info.online_cred,
        }
      })

      var listed = this.withdrawList.map(function (val) {
        let orders = JSON.parse(val.orders)[0]
        return {
          id: val.id,
          uuid: val.uuid,
          value: val.value == null ? 0 : val.value,
          date_solicitacao: val.created,
          month: orders.info.month,
          period: orders.info.period,
          last_online_cred: orders.info.last_online_cred,
          last_pos_cred: orders.info.last_pos_cred,
          online_cred: orders.info.online_cred,
          online_deb: orders.info.online_deb,
          online_pix: orders.info.online_pix,
          online_wallet: orders.info.online_wallet,
          pos_cred: orders.info.pos_cred,
          pos_deb: orders.info.pos_deb,
          pos_pix: orders.info.pos_pix,
          vendor_tax: ((val.vendorTax / 100).toFixed(2) * val.value).toFixed(2),
          status: val.proccessed == null ? 'Solicitada' : 'Processada',
          download: true,
        }
      })

      if (listed.length > 1) {
        listed.sort(function (a, b) {
          return a.date_solicitacao < b.date_solicitacao
            ? -1
            : a.date_solicitacao > b.date_solicitacao
            ? 1
            : 0
        })
      }

      return listed
    },
  },

  methods: {
    ...mapActions('report', [
      'fetchBillItems',
      'resetBillsState',
      'removeBufferItem',
      'getBillsMemBuffer',
      'removeMemBufferItem',
      'clearReportCacheFlags',
    ]),

    ...mapActions('product', ['fetchPOIs']),

    openModalInfoRelatorio() {
      this.showModalRelatorio = true
    },

    openModalTabelaReservas() {
      this.showModalTabelaReservas = true
    },

    closeModalTabelaReservas(boolean) {
      this.showModalTabelaReservas = false
    },

    changeUseChartCache(payload) {
      this.reportStoreCommit({
        mutation: 'SET_USE_CHART_CACHE',
        value: payload,
      })
    },

    setFieldsToPrint(field_label, visible) {
      this.fieldsRetirada.map((item) => {
        if (item.key == field_label) {
          item.visible = visible
        }
        return item
      })
    },

    async exportToPDF(printOnly) {
      this.hideWhilePrintingPDF = true
      let sDate = new Date(this.formDate.startDate + ' 12:00:00')
      let eDate = new Date(this.formDate.endDate + ' 12:00:00')

      if (!printOnly) {
        if (!this.indexedReport && this.formattedWithdraws.length > 0) {
          this.hideWhilePrintingPDF = false
          swal.fire({
            title: `Selecione um relatório`,
            text: `Para gerar um novo relatório selecione o relatório que será utilizado como base de vendas a crécido`,
            buttonsStyling: false,
            id: 'alert',
            confirmButtonClass: 'btn btn-primary',
          })
          return
        }
        if (!this.infoRelatorio.month) {
          this.hideWhilePrintingPDF = false
          swal.fire({
            title: `Informe de vendas`,
            text: `Insira os dados de vendas em maquininhas`,
            buttonsStyling: false,
            id: 'alert',
            confirmButtonClass: 'btn btn-primary',
          })
          return
        }

        await this.setFieldsToPrint('curr_pos', true)
        await this.setFieldsToPrint('total_transfer', true)
      }

      const userName = this.user.name
      var fileName =
        'janoo_' +
        userName +
        '_relatorio_vendas_' +
        sDate.toISOString().split('T')[0] +
        '_' +
        eDate.toISOString().split('T')[0] +
        '.pdf'

      await this.$nextTick()
      html2pdf(document.getElementById('print-this'), {
        margin: 1,
        filename: fileName,
        jsPDF: { orientation: 'landscape' },
      }).then(() => {
        this.hideWhilePrintingPDF = false
        this.setFieldsToPrint('curr_pos', false)
        this.setFieldsToPrint('total_transfer', false)
      })
    },

    hasModule(module) {
      let modules = []
      try {
        modules = this.params.User.modules
        if (typeof modules == 'string') {
          let _modules = []
          _modules[modules] = modules
          modules = _modules
        }
        modules = Object.keys(modules)
      } catch (error) {
        console.warn('nenhum módulo encontrado')
      }
      return modules.indexOf(module) >= 0
    },

    downloadAsCSV() {
      var csvData = []
      var current_booking_agents = {}
      var bookings_report_enabled = this.hasModule('enable_bookings_report')
      var agentsColsCount = 0

      if (typeof this.transformedItemsArray == 'object') {
        csvData = Object.values(this.transformedItemsArray).map(function (val) {
          // GROUPPING BY DEEPEST CATEGORY
          // let deeper_cat = val.cat.slice(-1)
          // deeper_cat = deeper_cat.pop()
          // deeper_cat = deeper_cat.slice(-1).pop()
          // deeper_cat = deeper_cat.description || deeper_cat.name
          var row = [
            // Reserva
            `"${val.code || val.id}"`,
            //atrativo
            `"${val.poi.name}"`,
            //Cat, Muniícpio
            val.cat,
            //...	QRCode, Conta Bocapio
            val.linkQrCode.replace(/\\/g, ''),
            //Status Reserva, Status do Item de compra
            val.statusText,
            //#Pedido
            // val.bid,
            //Agendado para
            // new Date(val.sdate * 1000).toISOString().split("T")[0],
            new Date(val.sdate * 1000).toString(),
            //Check-in
            val.checkin.searchText,
            //Check-in horário
            new Date(val.checkin.dateTime * 1000).toString(),
            //Pagador
            val.people.tableText.groupOwner
              ? val.people.tableText.groupOwner.replaceAll(',', ' | ')
              : '',
            //Pessoas
            val.people.tableText.count,
            //Valor
            val.finalValue,
            //Forma de pagamento
            val.paymentDescription +
              (val.confirmPayment.tableText &&
              val.confirmPayment.tableText.payment_method
                ? ' - ' + val.confirmPayment.tableText.payment_method
                : ''),
          ]

          // if (!bookings_report_enabled) {
          //Valor total
          // row.push(val.finalValue)
          //Forma de pagamento
          // row.push(val.paymentMethod)
          //Confirmação de pagamento
          // row.push(JSON.stringify(val.confirmPayment.tableText) || "")
          // }

          if (val.agents.length > agentsColsCount) {
            agentsColsCount = val.agents.length
          }

          val.agents.forEach((agent) => {
            var agent_name = agent.name

            if (current_booking_agents[agent.UUID + '-' + val.id]) {
              return
            }
            current_booking_agents[agent.UUID + '-' + val.id] = 1
            var agent_nickname = agent.nickname
            var agent_placename = agent.place
            if (agent_nickname != null && agent_nickname) {
              agent_name += ' (' + agent_nickname.trim() + ')'
            }
            row.push(agent_name)

            if (agent_placename == undefined) {
              agent_placename = ''
            }
            row.push(agent_placename)
          })
          return row
        })
      }

      var headers = []
      //Using node.js API
      if (bookings_report_enabled) {
        headers = [
          'Código',
          'Atrativo',
          'Localização',
          'Link QRCode',
          'Status',
          'Data',
          'Check-in',
          'Check-in horário',
          'Responsável',
          'Qtd. Pessoas',
          'Valor Final',
          'Forma de pagamento',
          //'Valor', 'Forma de pagamento', 'Status pagamento',
        ]
        for (var i = 0; i < agentsColsCount; i++) {
          headers.push('Condutor ' + (i + 1))
          headers.push('Associação ' + (i + 1))
        }
        csvData.unshift(headers)
      } else {
        headers = [
          'ID',
          'Produto',
          'Categoria',
          'Conta',
          'Status da Venda',
          'ID da Conta',
          'Status da Conta',
          'Data de compra',
          'OBS',
          'Quatidade',
          'Total',
          'Cliente',
          'Valor total',
          'Forma de pagamento',
          'Status pagamento',
        ]
        csvData.unshift(headers)
      }
      this.createCSVFile(csvData)
    },

    createCSVFile(csvData) {
      var universalBOM = '\uFEFF'
      let csvContent =
        'data:text/csv;charset=utf-8,' +
        universalBOM +
        csvData.map((e) => e.join(';')).join('\n')
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute(
        'download',
        `${this.user.username}_relatorio_vendas_janoo.csv`
      )
      jQuery('body')
        .append(link)
        .ready(function () {
          link.click()
        })
    },

    getLegendaChartArrecadacao(newLegenda) {
      if (newLegenda != null && newLegenda) {
        this.legendaChartArrecadacao = newLegenda
      } else {
        this.legendaChartArrecadacao = []
      }
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    addPercentSignal(row) {
      let result = isNaN(row.taxa) ? row.taxa : row.taxa + '%'
      return result
    },

    selectWithdrawReport(indexBooking) {
      if (this.indexedReport && this.indexedReport.id == indexBooking) {
        this.indexedReport = null
        return
      }
      this.indexedReport = this.formattedWithdraws.find(
        (el) => el.id == indexBooking
      )
      this.filterSelectedRowsToWithdraw()
    },

    downloadWithdrawReport(indexBooking) {
      this.indexedReport = this.formattedWithdraws.find(
        (el) => el.id == indexBooking
      )
      this.formDate.startDate = new Date(
        this.indexedReport.month + '-01 12:00:00'
      )
      this.formDate.endDate = new Date(
        this.formDate.startDate.getFullYear(),
        this.formDate.startDate.getMonth(),
        15
      ) //this.formDate.startDate.getMonth()-1, 0)
      this.formDate.startDate = this.formDate.startDate
        .toISOString()
        .split('T')[0]
      this.formDate.endDate = this.formDate.endDate.toISOString().split('T')[0]
      this.infoRelatorio.month = this.indexedReport.month
      this.fetchBillItems({
        startDate: this.formDate.startDate,
        endDate: this.formDate.endDate,
        useFakeData: this.useFakeData,
        operation_request: false,
      })
      this.fetchBillsAwait(0, this.exportToPDF)
      return
    },

    /**
     * Coleta todas as retiradas (withdraw) do usuário logado
     */
    fetchWithdraws(clearCache) {
      const { startDate, endDate } = this.formDate

      var sDate = new Date(startDate)
      var eDate = new Date(endDate)

      if (sDate.getTime() > eDate.getTime()) {
        swal.fire({
          title: `Erro! datas inicial e final invalidas !`,
          text: `a data final deve ser após a data inicial !`,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary',
        })
      }

      this.loadingTable = true

      nodeService
        .getWithdraws(
          this.formDate.startDate,
          this.formDate.endDate,
          clearCache
        )
        .then((response) => {
          this.loadingTable = false
          this.withdrawList = response.data
        })
        .finally(() => {
          this.infoRelatorio.month = this.indexedReport.month
        })
        .catch((error) => {
          this.loadingTable = false
        })
    },

    filterSelectedRowsToWithdraw() {
      this.selectedRows = this.formattedPaidBillItems.filter(function (
        val,
        idx
      ) {
        if (!val.isBcProcessed) {
          return val
        }
      })
      this.withdraw = {
        value: 0,
        data: {
          info: {
            month: '',
            ref_report_uuid: '',
            period: { start: '', end: '' },
            last_pos_cred: 0,
            last_online_cred: 0,
            online_cred: 0,
            online_deb: 0,
            online_pix: 0,
            online_wallet: 0,
            pos_cred: 0,
            pos_deb: 0,
            pos_pix: 0,
            local_money: 0,
            pois_tax: {},
            localpm: {},
            obs: '',
          },
          bookings: [],
        },
      }
      this.withdraw.data.info.month =
        this.infoRelatorio.month || this.formDate.startDate.substring(0, 10)
      this.withdraw.data.info.period.start = this.formDate.startDate.substring(
        0,
        10
      )
      this.withdraw.data.info.period.end = this.formDate.endDate.substring(
        0,
        10
      )

      if (this.selectedRows.length > 0) {
        var billItems = this.formattedPaidBillItems
        var vm = this
        this.pois.map((item) => {
          if (!item.commission) {
            item.commission = {
              commission_mode: 'percent',
              commission_value: 10,
              commission_fixed: '',
            }
          }

          if (item.commission) {
            vm.withdraw.data.info.pois_tax[item.uuid] =
              item.commission.commission_value
          }
          if (item.localpm && item.localpm.length) {
            vm.withdraw.data.info.localpm = item.localpm.reduce(
              (acc, curr) => ((acc[curr] = ''), acc),
              {}
            )
          }
        })

        this.withdraw.data.bookings = billItems.map(function (val, idx) {
          let pm = val.paymentMethod.split(' - ')[0]
          let final_value = val.finalValue
          if (vm.withdraw.data.info.pois_tax[val.poi.uuid] != undefined) {
            vm.global_vendor_tax =
              vm.withdraw.data.info.pois_tax[val.poi.uuid] / 100
            final_value -=
              final_value * (vm.withdraw.data.info.pois_tax[val.poi.uuid] / 100)
          } else {
            final_value = 0
          }
          return {
            id: val.id,
            date: new Date(val.sdate * 1000).toISOString().split('T')[0],
            value: val.finalValue,
            pm: pm,
            final_value: final_value,
          }
        })

        if (this.dataTableByPaymentMethod.length > 4) {
          console.error(
            'NEW PAYMENT METHOD FOUNDED!! ',
            this.dataTableByPaymentMethod
          )
          return false
        }

        this.withdraw.data.info.online_cred = this.dataTableByPaymentMethod[
          'CREDIT'
        ]
          ? this.dataTableByPaymentMethod['CREDIT']['value']
          : 0
        this.withdraw.data.info.online_cred -=
          this.withdraw.data.info.online_cred * this.global_vendor_tax

        this.withdraw.data.info.online_deb = this.dataTableByPaymentMethod[
          'DEBIT'
        ]
          ? this.dataTableByPaymentMethod['DEBIT']['value']
          : 0
        this.withdraw.data.info.online_deb -=
          this.withdraw.data.info.online_deb * this.global_vendor_tax

        this.withdraw.data.info.online_pix = this.dataTableByPaymentMethod[
          'PIX'
        ]
          ? this.dataTableByPaymentMethod['PIX']['value']
          : 0
        this.withdraw.data.info.online_pix -=
          this.withdraw.data.info.online_pix * this.global_vendor_tax

        this.withdraw.data.info.online_wallet = this.dataTableByPaymentMethod[
          'WALLET'
        ]
          ? this.dataTableByPaymentMethod['WALLET']['value']
          : 0
        this.withdraw.data.info.online_wallet -=
          this.withdraw.data.info.online_wallet * this.global_vendor_tax

        this.withdraw.data.info.pos_cred =
          this.infoRelatorio.posCreditCurrentMonth / 1
        this.withdraw.data.info.pos_cred -=
          this.withdraw.data.info.pos_cred * this.global_vendor_tax

        this.withdraw.data.info.pos_deb =
          this.infoRelatorio.posDebitCurrentMonth / 1
        this.withdraw.data.info.pos_deb -=
          this.withdraw.data.info.pos_deb * this.global_vendor_tax

        this.withdraw.data.info.pos_pix =
          this.infoRelatorio.posPixCurrentMonth / 1
        this.withdraw.data.info.pos_pix -=
          this.withdraw.data.info.pos_pix * this.global_vendor_tax
        this.withdraw.data.info.local_money = 0
        let lastCCPayment = {}

        if (this.indexedReport) {
          this.withdraw.data.info.ref_report_uuid = this.indexedReport.uuid
          lastCCPayment = this.withdrawCCList[this.indexedReport.period.start]
        } else {
          lastCCPayment = this.getLastCCPayment(
            this.withdraw.data.info.period.start
          )
        }
        // console.log('lastCCPayment',lastCCPayment)

        this.withdraw.data.info.last_pos_cred = lastCCPayment.pos
        this.withdraw.data.info.last_online_cred = lastCCPayment.online
        // Vendas Janoo: Soma de todas as reservas pagas online (Pix) e por carteira
        // this.withdraw.value = this.withdraw.data.bookings.filter(booking => booking.pm == 'wallet' || booking.pm == 'pix').reduce(function (acc, val, idx) {
        //   acc = acc + (val.value - val.value * vm.global_vendor_tax)
        //   return acc
        // }, 0)
        this.withdraw.value += this.withdraw.data.info.online_deb
        this.withdraw.value += this.withdraw.data.info.online_pix
        this.withdraw.value += this.withdraw.data.info.online_wallet

        // Vendas POS: Valores pagos na Maquininha POS (Débito).
        // console.log('this.withdraw.data.info.localpm[debito]',JSON.stringify(this.withdraw.data.info.localpm), this.withdraw.data.info.localpm['debit'] != undefined,this.withdraw.data.info.localpm['debit'])

        if (this.withdraw.data.info.localpm['debit'] == undefined) {
          this.withdraw.value += this.withdraw.data.info.pos_deb
        }

        // Vendas POS: Valores pagos na Maquininha POS (PIX)
        if (this.withdraw.data.info.localpm['pix'] == undefined) {
          this.withdraw.value += this.withdraw.data.info.pos_pix
        }

        // Vendas POS: Valores pagos na Maquininha POS no período anterior (Crédito)
        if (this.withdraw.data.info.localpm['credit'] == undefined) {
          this.withdraw.value += this.withdraw.data.info.last_pos_cred
        }

        // Vendas POS:  Soma de todas as reservas pagas online no período anterior (Crédito)
        this.withdraw.value += this.withdraw.data.info.last_online_cred
      } else {
        // this.withdraw = {}
      }
    },

    isBcProcessed(row, index) {
      return !row.isBcProcessed
    },

    getWithdrawBillItems() {
      this.fetchBillsAwait(0, this.saveWithdraw)
    },

    async saveWithdraw() {
      if (!this.indexedReport && this.formattedWithdraws.length > 0) {
        swal.fire({
          title: `Selecione um relatório`,
          text: `Para gerar um novo relatório selecione o relatório que será utilizado como base de vendas a crécido`,
          buttonsStyling: false,
          id: 'alert',
          confirmButtonClass: 'btn btn-primary',
        })
        return
      }

      this.withdraw.data.info.obs = this.infoRelatorio.obs
      this.loadingTable = true

      nodeService
        .saveWithdraw([this.withdraw.data], this.withdraw.value)
        .then((res) => {
          this.loadingTable = false
          this.loadingTableByPaymentMethod = false
          this.showModalRelatorio = false
          var response = res.data
          this.toggleSelection()
          this.fetchWithdraws(true)
          var vm = this
          this.formattedPaidBillItems.forEach(function (value, index) {
            vm.withdraw.data.bookings.forEach(function (val, idx) {
              if (val.id == value.id) {
                value.isBcProcessed = true
              }
            })
          })

          swal
            .fire({
              title: response.status == 'success' ? 'Sucesso' : 'Falha',
              text: 'Pronto! Sua solicitação de retirada já está sendo processada!',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-default',
              icon: response.status == 'success' ? 'success' : 'error',
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.exportToPDF()
              }
            })
        })
        .catch((err) => {
          this.loadingTable = false
          this.loadingTableByPaymentMethod = false
          console.error(err)
        })
        .finally(() => {
          this.loadingTable = false
          this.loadingTableByPaymentMethod = false
        })
    },

    async loadReport(startDate, endDate) {
      if (!this.formDate.startDate) {
        this.formDate.startDate = moment(this.todayReferenceDate)
          .startOf('month')
          .format('YYYY-MM-DD')
      }

      if (!this.formDate.endDate) {
        this.formDate.endDate = moment(this.todayReferenceDate)
          .endOf('month')
          .format('YYYY-MM-DD')
      }

      if (!startDate || !endDate) {
        startDate = this.formDate.startDate
        endDate = this.formDate.endDate
      }

      var diff = moment(endDate).diff(moment(startDate), 'days')
      if (diff < 0) {
        swal.fire({
          title: `Atenção!`,
          text: `a data final deve ser após a data inicial!`,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary',
        })
        return
      }
      this.loadingTable = true
      this.loadingTableByPaymentMethod = true
      this.noCheckinCount = 0

      this.resetBillsState()
      this.clearReportCacheFlags()
      this.calculateFetchProgress()
      this.fetchBillItems({
        startDate,
        endDate,
        useFakeData: this.useFakeData,
        daysInternval: 1,
        operation_request: false,
      })

      setTimeout(() => {
        this.fetchBillsAwait()
      }, 0)
    },

    fetchBillsAwait(idx, callback) {
      this.getBillsMemBuffer().then((bufferData) => {
        this.billsMemBuffer = bufferData
      })

      if (!idx) {
        idx = 1
      }
      let popped = false

      if (this.billsMemBuffer.length >= idx) {
        popped = this.billsMemBuffer[idx - 1]
        this.removeMemBufferItem(idx - 1)
        idx++
      }

      let doneStatusCount = this.$store.state.report.requestArrayStatus.filter(
        (resp) => resp == 'done'
      ).length
      var totalRequest = this.$store.state.report.requestArrayStatus.length
      let doneBufferCount = this.billsMemBuffer.filter(
        (resp) => resp == 0
      ).length

      if (
        doneStatusCount == 0 ||
        doneStatusCount < totalRequest ||
        doneBufferCount < totalRequest
      ) {
        setTimeout(
          (i, cb) => {
            this.fetchBillsAwait(i, cb)
          },
          100,
          idx
        )
      } else {
        if (Object.keys(this.transformedItemsArray).length == 0) {
          this.$notify({
            message: 'Nehuma reserva encontrada neste período!',
            duration: 3000,
            type: 'warning',
          })
        }

        this.loadingTable = false
        this.loadingTableByPaymentMethod = false
        this.filterSelectedRowsToWithdraw()
        if (callback) {
          callback.call()
        }
      }

      this.calculateFetchProgress()
    },

    fillsFormDate() {
      this.formDate.startDate = moment(this.todayReferenceDate)
        .startOf('month')
        .format('YYYY-MM-DD')
      this.formDate.endDate = moment(this.todayReferenceDate)
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    toggleSelection(rows) {
      if (this.$refs.multipleTable) {
        if (rows) {
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row)
          })
        } else {
          this.$refs.multipleTable.clearSelection()
        }
      }
    },

    deleteRow(row) {
      let indexToDelete = this.transformedItemsArray.findIndex(
        (tableRow) => tableRow.id === row.id
      )
      if (indexToDelete >= 0) {
        this.transformedItemsArray.splice(indexToDelete, 1)
      }
    },

    setTotalsPersonsTypes(total_persons_types) {
      this.totalsPersonsTypes = total_persons_types
    },

    getLastCCPayment(day) {
      let lastCCPayment = { pos: 0, online: 0 }
      let date = new Date(day + ' 12:00:00')
      date.setMonth(date.getMonth() - 1)
      day = date.toISOString().substring(0, 10)
      if (this.withdrawCCList[day] != undefined) {
        lastCCPayment = this.withdrawCCList[day]
      }
      return lastCCPayment
    },

    calculateFetchProgress() {
      var totalRequest = this.$store.state.report.requestArrayStatus.length
      var done = this.billsMemBuffer.filter((resp) => resp == 0).length
      let progress = (done / totalRequest) * 100
      this.fetchProgress = done > 0 ? progress : 0.1

      if (progress == 100 && this.checkWithdraw) {
        // console.log('FIM DA EXECUÇAO')
        const vm = this
        Object.keys(this.withdraw_test.bookings).forEach((idx) => {
          let booking = vm.transformedItemsArray.find((el) => {
            return el.id == vm.withdraw_test.bookings[idx]['id']
          })

          if (booking == undefined) {
            // console.log('reserva não encontrada ',vm.withdraw_test.bookings[idx])
          } else {
            if (booking.finalValue != vm.withdraw_test.bookings[idx]['value']) {
              // console.log('divergencia de valor ',vm.withdraw_test.bookings[idx],booking)
            }

            let pmBooking = booking.paymentMethod.replace('pos_', '')
            let pmWTD = vm.withdraw_test.bookings[idx]['pm']
              .replace('Pagamento por carteira', 'wallet')
              .replace('Pix', 'pix')
              .replace('Cartão de Crédito', 'credit')
              .replace('Cartão', 'credit')
              .replace('Crédito', 'credit')
              .replace('credito', 'credit')
              .replace('debito', 'debit')
              .replace('dinheiro', 'money')
              .replace('--', 'cortesia')

            if (pmBooking != pmWTD) {
              // console.log('divergencia de método de pagamento ',pmBooking , pmWTD,booking.paymentMethod , vm.withdraw_test.bookings[idx]['pm'],vm.withdraw_test.bookings[idx],booking)
            }
          }
        })
      }
    },
  },
}
</script>

<style>
@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: spinner-border 0.75s linear infinite;
  animation: spinner-border 0.75s linear infinite;
}
/*
.modal-content {
    max-height: 600px;
  }
*/
</style>
